import { config } from "../env";
import { Delete, get, patch, post } from "./helpers/http-handler";

// export const adminGetAuditDashboardInfo = (queryRequest: string) =>
// 	get(`${process.env.REACT_APP_API_URL?process.env.REACT_APP_API_URL:config.API_URL}/audit/dashboard-info?${queryRequest}`);

export const adminGetAuditDashboardInfo = (payload: object) =>
	post(`${process.env.REACT_APP_API_URL?process.env.REACT_APP_API_URL:config.API_URL}/audit/dashboard-info`,payload);

export const adminGetAuditList = (queryRequest:string) =>
	get(`${process.env.REACT_APP_API_URL?process.env.REACT_APP_API_URL:config.API_URL}/audit?${queryRequest}`);

export const adminUpdateAudit = (id: string, payload: object) =>
	patch(`${process.env.REACT_APP_API_URL?process.env.REACT_APP_API_URL:config.API_URL}/audit`, payload);

export const adminGetAllAuditList = (queryRequest:string) =>
	get(`${process.env.REACT_APP_API_URL?process.env.REACT_APP_API_URL:config.API_URL}/audit/list-all?${queryRequest}`);
